import MomioButton from '../reusablesComponent/momioButton';
import { useMomiosData } from '../../../../hooks/useMomiosData';

/**
 * Componente optimizado para mostrar momios de apuestas en eventos de tenis
 * Renderiza botones de momios (jugador 1, jugador 2) con funcionalidad de click
 * Se adapta automáticamente según la casa de apuestas (Strendus o Caliente)
 */
export default function MomiosTenisComponent({ centerClass, item = {}, handleClickCard, isStrendus }) {
  
  // Hook personalizado para manejar datos de momios
  const { getMomioData } = useMomiosData(item, isStrendus);

  /**
   * Configuración de momios para tenis (solo left y right)
   */
  const momiosConfig = [
    {
      position: 'left',
      isMayor: true
    },
    {
      position: 'right', 
      isMayor: true
    }
  ];

  return (
    <div 
      className={centerClass} 
      onClick={(e) => handleClickCard(e, item.opta_event_url)}
      role="group"
      aria-label="Momios de apuestas para tenis"
    >
      {momiosConfig.map(({ position, isMayor }) => {
        const momioData = getMomioData(position);
        
        return (
          <MomioButton 
            key={position}
            url={momioData.url}
            value={momioData.value}
            handleClickCard={handleClickCard}
            isMayor={isMayor}
            className=" cursorAuto"
          />
        );
      })}
    </div>
  );
}